import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { GridOverlay } from "@mui/x-data-grid-pro";

interface ITableOverlayProperties {
  subtitle: string;
  title: string;
}

const TableOverlay = ({ subtitle, title }: ITableOverlayProperties) => {
  return (
    <GridOverlay>
      <div
        style={{
          alignItems: "center",
          backgroundColor: "rgba(255, 255, 255, 0.75)",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <CircularProgress />
        <Typography style={{ marginTop: 10 }} variant="h6">
          {title}
        </Typography>
        <Typography style={{ fontWeight: "700", marginTop: 10 }}>{subtitle}</Typography>
      </div>
    </GridOverlay>
  );
};

export default TableOverlay;
